// Domain
import { UploadIdStatesEnumeration } from '../enumerations/upload-id-states.enumeration';

const DOMAIN = 'lending.services.public.onboarding.lzOnboarding.uploadIdContainer.';

const FETCHING_DESCRIPTION = `${DOMAIN}fetching.description`,
  FETCHING_TITLE = `${DOMAIN}fetching.title`,
  UPLOAD_ID_TITLES = {
    [UploadIdStatesEnumeration.LANDING]: `${DOMAIN}uploadFlowsConfiguration.landingTitle`,
    [UploadIdStatesEnumeration.DIFFERENT_DATA]: `${DOMAIN}uploadFlowsConfiguration.differentDataTitle`,
  };

export { FETCHING_DESCRIPTION, FETCHING_TITLE, UPLOAD_ID_TITLES };
